import type { Layer } from "@/types/legend.types";
import type { Legend, NoteConfig } from "@/types/legend.types";

export type HexaColour = `#${string}`;
export default class LegendLib {
  static getComputedColor(
    note: NoteConfig,
    legend: Partial<Legend>
  ): HexaColour {
    if (note.props.color === "kByLayer" && note.props.layerId) {
      return LegendLib.getLayerColor(note.props.layerId, legend);
    } else if (note.props.color == "kByBlock") {
      // TO be added when adding blocks
      return "#000000";
    } else {
      return LegendLib.toHex(note.props.color);
    }
  }
  // decode a string as "R,G,B" to [R,G,B]
  static toRGB(color: string): [number, number, number] | undefined {
    const matches = color.match(/\d{1,3}/g);
    if (matches && matches.length === 3) {
      const [R, G, B] = matches.map((str) => Number(str));
      return [R, G, B];
    } else {
      return undefined;
    }
  }

  static toHex(color: string | number[] | undefined): HexaColour {
    if (!color) return "#000000";
    if (Array.isArray(color)) {
      return LegendLib.rgbToHex(color as [number, number, number]);
    }
    const c = LegendLib.toRGB(color);
    if (!c) return "#000000";
    return ("#" +
      LegendLib._componentToHex(c[0]) +
      LegendLib._componentToHex(c[1]) +
      LegendLib._componentToHex(c[2])) as HexaColour;
  }

  static rgbToHex(color: [number, number, number]): HexaColour {
    return ("#" +
      LegendLib._componentToHex(color[0]) +
      LegendLib._componentToHex(color[1]) +
      LegendLib._componentToHex(color[2])) as HexaColour;
  }

  static _componentToHex(c: number): string {
    const hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  static getLayerColor(
    layerId: Layer["id"],
    legend: Partial<Legend>
  ): HexaColour {
    const layer = legend.layer_configs?.find((layer) => layer.id === layerId);
    if (!layer || !layer.color) return "#000000";
    return LegendLib.toHex(layer.color);
  }
}
